import React from "react";
import TriloChatDocPanel from "./TriloChatDocPanel";
import { renderMarkdown } from "../utils/triloChatMarkdown";
import { DOC_REFERENCE_PATTERN } from "../utils/triloChatConstants";

/**
 * TriloChatMessageContent
 *
 * Body of an assistant reply: Markdown rendered to HTML, with any
 * `[DOC:<id>]` marker replaced by an inline document panel.
 *
 * Props:
 * - content: Raw reply text
 * - sessionId: Session the reply belongs to (needed to fetch referenced docs)
 */
const TriloChatMessageContent = ({ content, sessionId }) => {
  // A fresh RegExp per render: a shared global one would carry `lastIndex`
  // across calls and start matching mid-string.
  const docPattern = new RegExp(DOC_REFERENCE_PATTERN, "g");
  const parts = [];
  let last = 0;
  let match;

  while ((match = docPattern.exec(content)) !== null) {
    if (match.index > last) {
      const html = renderMarkdown(content.slice(last, match.index));
      parts.push(<div key={last} dangerouslySetInnerHTML={{ __html: html }} />);
    }
    parts.push(
      <TriloChatDocPanel
        key={match[1]}
        contentId={match[1]}
        sessionId={sessionId}
      />
    );
    last = match.index + match[0].length;
  }
  if (last < content.length) {
    const html = renderMarkdown(content.slice(last));
    parts.push(<div key={last} dangerouslySetInnerHTML={{ __html: html }} />);
  }

  if (!parts.length) {
    return (
      <div dangerouslySetInnerHTML={{ __html: renderMarkdown(content) }} />
    );
  }
  return <>{parts}</>;
};

export default TriloChatMessageContent;
